import React, { FC, useState, useEffect } from 'react'
import { IonModal, IonContent, IonFooter, IonHeader } from '@ionic/react'
import { cartMobx } from 'restaurant'
import { observer } from 'mobx-react'
import { compact } from '@dt/fe-utils/dist/lodash'
import { multiPersonMobx } from '@mobxStore'
import './index.scss'
import { resolve } from 'dns'
import { Avatar } from '@cps'

interface IProps {
  reject?: any;
  resolve?: any;
  pks: string[];
}

const MultiCntModal: FC<IProps> = ({ reject, resolve, pks }) => {
  const cartItems = compact(pks.map(pk => cartMobx.pkToViewCartItemMap[pk]))
  if (cartItems.length === 0) {
    setTimeout(() => {
      reject()
    }, 200)
  }
  return (
    <IonModal
      isOpen
      cssClass='multicnt-modal sub-modal'
      swipeToClose
      onDidDismiss={() => reject()}
    >
      <IonHeader>
        <div className='time-pick-header'>
          <span>
            {
              i18n.t('common.delete')
            }
            {
              !!cartItems.length && cartItems[0].name
            }
          </span>
          {/* <i className='iconfont icon-close' data-cypid='multicntModalClose' onClick={reject}></i> */}
        </div>
      </IonHeader>
      <IonContent>
        <div className='multi-users'>
          {
            cartItems.map(cartItem => {
              const requiredMinCnt = cartMobx.getRequiredProductMinCnt(cartItem.productNo, cartItem.cnt, cartItem)
              const isRequiredMinCnt = requiredMinCnt !== undefined && cartItem.cnt <= requiredMinCnt
              return (
                <div className='multi-user-item' key={cartItem.pk}>
                  <div>
                    <Avatar userKey={cartItem.addUserId} />
                    {multiPersonMobx.multiPersonMap[cartItem.addUserId]?.nickName}
                  </div>
                  <div className='item-handle'>
                    <i
                      className={`iconfont icon-shuliangjian2x${isRequiredMinCnt ? ' disabled' : ''}`}
                      data-cypid={`multiUserItem_pk_${cartItem?.pk}`}
                      onClick={() => {
                        if (isRequiredMinCnt) return
                        cartMobx.reduce(cartItem.pk)
                      }}
                    />
                    <span>{cartItem.cnt}</span>
                    <i className='iconfont icon-add' />
                  </div>
                </div>
              )
            })
          }
        </div>
      </IonContent>
      <IonFooter>
        <button data-cypid='multicntModalConfirm' onClick={resolve}>
          {i18n.t('common.ok')}
        </button>
      </IonFooter>
    </IonModal>
  )
}

export default observer(MultiCntModal)
